<app-programtitle title="Rolling a dice"></app-programtitle>
<p> Write a program to roll a dice 1000 times and count how many time each number occurred.</p>
<p>This program uses python randrange function to generate random numbers.</p>
<app-editor code="{{program}}"> </app-editor>